module.exports = __webpack_public_path__ + "static/media/m9cr0.a170f99f.png";